
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-in-one-pos-billing-software",
      function () {
        return require("private-next-pages/all-in-one-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-in-one-pos-billing-software"])
      });
    }
  